//import React, { useEffect } from 'react';
import '../styles/global_styles.css';
import Header from '../components/Header';
import globalStore from '../store/global';
import MostrarPreguntasFrecuentes from '../components/MostrarPreguntasFrecuentes';
import Footer from '../components/Footer';

const PFs = () => {

    const { seccion, setSeccion } = globalStore();

    const navegarA = (destino: string) => {
        setSeccion(destino);
        let seccionElement = document.getElementById(destino);
        if (seccionElement === null) return;
        seccionElement.scrollIntoView({ behavior: 'smooth' });
    };
              
    return (
        <div className="flex flex-col h-screen ">
            <Header navegacionFija={true} seccionActual={'faq'} cambiarSeccion={navegarA}></Header>
            <div className="bg-white flex flex-col flex-grow">
                <MostrarPreguntasFrecuentes />
            </div>
            <Footer id="footer" />
        </div>
    );
};

export default PFs;